import { getLocaleUnit } from 'careit';
import { useMemo } from 'react';
import useAuth from './useAuth';

const useLocaleUnit = () => {
  const { user } = useAuth();
  let localeUnit = useMemo(() => getLocaleUnit(user), [user]);
  return localeUnit;
};

export default useLocaleUnit;
